<template>
    <div class="DM_riskControlList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item style="width:130px;">
                    <el-radio v-model="searchForm.type" :label="1" @change="typeChange">团队</el-radio>
                    <el-radio v-model="searchForm.type" :label="2" @change="typeChange">直营</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-select
                            v-model="searchForm.brand_id"
                            filterable
                            clearable
                            style="width:100%"
                            placeholder="请选择终端类型"
                    >
                        <el-option
                                v-for="(item,index) in brandList"
                                :label="item.name"
                                :value="item.id"
                                :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="searchForm.status"
                        clearable
                        placeholder="请选择扣款状态"
                    >
                        <el-option label="扣款成功" value="1"></el-option>
                        <el-option label="扣款失败" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="searchForm.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input clearable v-model="searchForm.phone" placeholder="请输入归属代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="rangeDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="onSearch(searchForm)"
                    >查询</el-button>
                     <el-button
                            size="small"
                            type="primary"
                            icon="el-icon-download"
                            :loading="downLoading"
                            @click="handleDownLoad(searchForm)"
                    >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="backList"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
                    max-height="1000px"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 伪激活扣款订单号 -->
                <!-- <el-table-column
                        header-align="center"
                        align="center"
                        prop="order_num"
                        label="伪激活扣款订单号"
                        min-width="120"
                ></el-table-column> -->
                <!-- 终端归属代理名称 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="brand_name"
                        label="终端类型"
                        min-width="120"
                ></el-table-column>
                <!-- sn -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="terminal_sn"
                        label="SN"
                        min-width="166"
                ></el-table-column>
                <!-- 商户名称 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="m_name"
                        label="商户名称"
                        min-width="166"
                ></el-table-column>
                <!-- 终端归属代理名称 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="real_name"
                        label="终端归属代理名称"
                        min-width="120"
                ></el-table-column>
                <!-- 终端归属代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    :label="level > 1 ? '终端所属团队手机号' : '终端归属代理手机号'"
                    min-width="150"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 终端归属代理编号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    :label="level > 1 ? '终端所属团队编号' : '终端归属代理编号'"
                    min-width="150"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone" placement="top">
                      <p>{{ scope.row.agent_no | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 应扣款金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="deduction_money"
                        label="扣款金额"
                        min-width="80"
                ></el-table-column>
                <!-- 本人扣款金额 -->
                <el-table-column v-if="level>1"
                        header-align="center"
                        align="center"
                        prop="dec_money"
                        label="我的扣款"
                        min-width="120"
                ></el-table-column>
                <!-- 状态 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="status_type"
                        label="状态"
                        min-width="80"
                >
                    <template slot-scope="scope">
                        <p  v-if="scope.row.status_type=='扣款失败'" style="color:red" v-html="scope.row.status_type"></p>
                        <p  v-if="scope.row.status_type=='扣款成功'" style="color:green" v-html="scope.row.status_type"></p>
                    </template>
                </el-table-column>
                <!-- 扣除时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="deduction_time"
                        label="扣款时间"
                        min-width="150"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10,20,50,100]"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <back-info v-if="detail.isShow" :detail="detail" @infoClose="infoClose"></back-info>
    </div>
</template>

<script>
import backInfo from './DM_riskControlInfo';
export default {
    name: "DM_riskControlList",
    data() {
        return {
            tableTitle: {
                my_money: 0,
                total_money: 0,
                total: 0,
            },
            detail: { //详情
                isShow: false,
                info: {}
            },
            brandList: [],
            searchForm: {
                page: 1,
                limit: 10,
                brand_id: '', //终端类型
                terminal_sn: '', //sn
                phone: '', //归属人账号
                start_time: '',
                end_time: '',
                type: 1,
                status: '',
            },
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            backList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            downLoading: false, //导出loading
            level: sessionStorage.getItem('level')
        }
    },
    mounted() {
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$$message.success(res.msg);
            }
        });
        this.getData({
            page: 1,
            limit: 10,
            type: 1,
        })
    },
    components: {
        backInfo
    },
    methods: {
        typeChange(val) { //监听radio
            this.searchForm.type = val;
            this.currentPage = 1; //重置分页
            this.searchForm.page = 1; //重置
            // 表单提交
            this.getData();
        },
        onSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData();
        },
        handleInfo(row) { //详情
            this.detail.isShow = true;
            this.detail.info = row;
        },
        infoClose() {
            this.detail.isShow = false;
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData();
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData();
        },
        getData() { //获取数据
            this.loading = true;
            this.$api.post("brand_risk_control/get_brand_risk_control_trigger", this.searchForm, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.backList = res.data.list;
                    //渲染结束后取消加载
                    this.loading = false;
            })
        },
        handleDownLoad(searchForm) { //导出
            this.downLoading = true;
            this.$api.post("brand_risk_control/get_brand_risk_control_trigger_download", searchForm, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    var link=this.$file_url+res.data;
                    window.open(link)
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.downLoading = false;
            })
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            console.log(this.searchForm.start_time)
            this.rangeDate = [this.searchForm.start_time, this.searchForm.end_time];
        },
    }
};
</script>

<style lang="scss" scope>
.DM_riskControlList {
  .el-input__inner {
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor .el-range-input,
  .el-date-editor .el-range-separator {
    font-size: 12px;
  }
  .el-popover__title {
    font-size: 12px;
    font-weight: 700;
  }
  .tableTitle {
    display: inline-block;
    margin-right: 20px;
  }
}
</style>
